import { render, staticRenderFns } from "./1-EntityDetails.vue?vue&type=template&id=7051e056&scoped=true"
import script from "./1-EntityDetails.vue?vue&type=script&lang=js"
export * from "./1-EntityDetails.vue?vue&type=script&lang=js"
import style0 from "./1-EntityDetails.vue?vue&type=style&index=0&id=7051e056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051e056",
  null
  
)

export default component.exports